import React, { Component } from 'react';

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <p>About</p>;
  }
}

export default About;
